/**
 * Vuex Store Type Constants
 */

export const LOAD_ITEM = 'LOAD_ITEM'
export const LOAD_ITEMS = 'LOAD_ITEMS'

export const SET_ITEM = 'SET_ITEM'
export const SET_ITEMS = 'SET_ITEMS'

export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'

export const ADD_CRUMB = 'ADD_CRUMB'
export const REMOVE_CRUMB = 'REMOVE_CRUMB'
export const SET_CRUMB = 'SET_CRUMB'
export const UNSET_CRUMB = 'UNSET_CRUMB'

export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const SET_USER = 'SET_USER'
export const UNSET_USER = 'UNSET_USER'

export const LOAD_SETTINGS = 'LOAD_SETTINGS'
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'
export const SET_SETTINGS = 'SET_SETTINGS'
export const RESET_SETTINGS = 'RESET_SETTINGS'

export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS'
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'

export const ADD_QUEUE = 'ADD_QUEUE'
export const LOAD_QUEUE = 'LOAD_QUEUE'
export const SET_QUEUE = 'SET_QUEUE'

export const START_TIMER = 'START_TIMER'
export const WARN_TIMER = 'WARN_TIMER'
export const TIMER_STATUS = 'TIMER_STATUS'
export const CANCEL_TIMER = 'CANCEL_TIMER'
export const SET_TIMER = 'SET_TIMER'
export const SET_WARN = 'SET_WARN'
export const UNSET_TIMER = 'UNSET_TIMER'


// WEBPACK FOOTER //
// ./src/lib/store/types.js